import * as React from 'react';
import classNames from 'classnames';
import './pages.module.scss';
import { BackButton } from '../buttons/BackButton';

type ContainerProps = {
    children: any;
    id?: string;
    className?: string;
    styleName?: string;
};
export const Page = ({ children, id, className }: ContainerProps) => (
    <div styleName="page" className={className} id={id}>
        {children}
    </div>
);
export const Pane = ({ children, className = undefined }: ContainerProps) => (
    <div styleName="pane" className={className}>
        {children}
    </div>
);
export const PageBody = ({ children, className = undefined }: ContainerProps) => (
    <div styleName="page-body" className={className}>
        {children}
    </div>
);

type ChildrenOnlyProps = {
    children: any;
};
export const PaneHeader = ({ children }: ChildrenOnlyProps) => <div styleName="pane-header">{children}</div>;
export const PaneBody = ({ children }: ChildrenOnlyProps) => <div styleName={'pane-body'}>{children}</div>;
export const StepIndicator = ({ children }: ChildrenOnlyProps) => <div styleName={'step-indicator'}>{children}</div>;

type StepProps = {
    children: any;
    active: boolean;
};
export const Step = ({ children, active }: StepProps) => (
    <div styleName={classNames('step', { active: active })}>{children}</div>
);
export const PaneBackButton = () => <BackButton styleName="back-button" />;
